<template>
  <v-dialog v-model="irrigationOrderDialog" persistent max-width="600">
    <app-snackbar
    :text = "snackBarText"
    :show.sync = "snackbar"
    :color = "snackbarColor"
    :timeOut = "timeOut"
    ></app-snackbar>
    <v-card>
      <v-card-title>
        <h2>ORDEN DE RIEGO</h2>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-select v-model="dataLot" :items="crops" label="Lote" ></v-select>
          <v-text-field v-model="dataLamina" step="any" type="number" min="1" max="50" label="Lámina" ></v-text-field>
          <div class="d-flex padding-col" cols="12">
            <div class="d-flex padding-subdate" cols="6" >
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-text-field  v-model="dateFrom" label="Desde" prepend-icon="event" readonly v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker v-model="dateFrom" :min="new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10)">
                </v-date-picker>
              </v-menu>
            </div>
            <div class="d-flex padding-subdate" cols="6" >
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-text-field  v-model="dateTo" label="Hasta" prepend-icon="event" readonly v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker v-model="dateTo" :min="new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10)">
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('update:irrigationOrderDialog', false)">Cancelar</v-btn>
        <v-btn color="info" text @click="sendWhatsapp()">Emitir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { USER_QUERY } from '../../../../constants/graphql';
  export default {
    data () {
      return {
        lots: ['1', '2', '3', '4'],
        dataLot: '',
        dataLamina: '',
        dateFrom: '',
        dateTo: '',
        snackbar: false,
        snackBarText: '',
        snackbarColor: 'red',
        timeOut: 5000,
        User: {}
      };
    },
    apollo: {
      User: {
        query: USER_QUERY,
        variables () {
          return {
            id: this.$store.getters.user.id
          };
        }
      }
    },
    props: {
      deviceId: {
        type: String
      },
      device: {
        type: Object
      },
      irrigationOrderDialog: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      crops () {
        if (!this.device.Crops) {
          return ['Lote 1'];
        }
        return this.device.Crops.map((item) => item.name);
      },
      lastEventDate () {
        if (this.device.Event) {
          return new Date(this.device.Event.dateTime);
        } else {
          return null;
        }
      }
    },
    methods: {
      sendWhatsapp () {
        if (!this.dateFrom.length || !this.dateTo.length || !this.dataLamina.length || !this.dataLot.length) {
          this.snackbar = true;
          this.snackBarText = 'Por favor, completar los datos';
          return;
        }
        if (this.dateFrom > this.dateTo) {
          this.snackbar = true;
          this.snackBarText = 'Por favor, verificar fechas';
          return;
        }
        if (this.dataLamina > 50 || this.dataLamina < 1) {
          this.snackbar = true;
          this.snackBarText = 'Por favor, verificar lámina';
          return;
        }
        const currentDate = new Date();
        const userName = this.User.name;
        const irrigationText = `*Orden de Riego* %0A ${this.dataLamina}mm para ser regados entre ${this.dateFrom.substr(8, 2)}/${this.dateFrom.substr(5, 2)} y ${this.dateTo.substr(8, 2)}/${this.dateTo.substr(5, 2)}, en el lote ${this.dataLot} %0A Saludos, ${userName} %0A %0A Fecha de emision: ${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
        const variables = {
          name: '',
          dateTime: currentDate.toISOString(),
          note: `${this.dataLamina}mm - Lote ${this.dataLot} <br> ${this.dateFrom.substr(8, 2)}/${this.dateFrom.substr(5, 2)} - ${this.dateTo.substr(8, 2)}/${this.dateTo.substr(5, 2)} <br> ${userName}`,
          deviceId: parseInt(this.deviceId)
        };
        this.$store.dispatch('uploadIrrigationOrder', {
          variables: variables,
          comesFromStore: false,
          key: null
        });
        this.$emit('update:irrigationOrderDialog', false);
        mixpanel.track('Create irrigation order',
          {
            'id': this.deviceId,
            'text': irrigationText
          }
        );
        window.open(
            `https://api.whatsapp.com/send?text=${irrigationText}`,
            '_blank'
        );
      }
    }
  };
</script>


// WEBPACK FOOTER //
// IrrigationOrderModal.vue?d20c0d10